import svgXSrc from '@cowprotocol/assets/cow-swap/x.svg'
import { SearchInput } from '@cowprotocol/ui'

import { t } from '@lingui/core/macro'
import SVG from 'react-inlinesvg'
import styled from 'styled-components/macro'

interface HookSearchInputProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  ariaLabel?: string
  style?: React.CSSProperties
  onClear?: () => void
}

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
`

const ButtonIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`

const ClearButton = styled(ButtonIcon)`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.4;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 1;
  }

  > svg {
    width: 14px;
    height: 14px;
    color: inherit;
  }

  > svg > path {
    fill: currentColor;
  }
`

// TODO: Add proper return type annotation
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function HookSearchInput({ value, onChange, placeholder, ariaLabel, onClear }: HookSearchInputProps) {
  return (
    <SearchContainer>
      <SearchInput
        placeholder={placeholder ? placeholder : t`Search hooks...`}
        value={value}
        onChange={onChange}
        aria-label={ariaLabel ? ariaLabel : t`Search hooks`}
        style={{ paddingRight: '38px' }}
      />
      {value && (
        <ClearButton onClick={onClear} aria-label={t`Clear search input`}>
          <SVG src={svgXSrc} />
        </ClearButton>
      )}
    </SearchContainer>
  )
}
